import React, { Component } from 'react';
import styled from 'styled-components';
import PageHeader from '../components/PageHeader';
import SearchStoreActions from '../flux/SearchStoreActions';
import SearchStore from '../flux/SearchStore';
import __ from '../utils/translator';
import getSearchQueryFromQueryString
  from '../utils/getSearchQueryFromQueryString';
import PageTitle from '../components/PageTitle';
import resultRenderFactory from "../utils/resultRenderFactory";
import NoResults from "../components/NoResults";
import Header from '../components/organisms/Header';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import RenderOnMobile from '../components/responsive/RenderOnMobile';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import buttonMutedStyle from '../utils/buttonMutedStyle';
import { default as SearchIcon } from "../icons/Search";

class Search extends Component {
  state = {
    collectionCover: null,
    searchQuery: getSearchQueryFromQueryString(this.props.location.search),
    results: null,
  };

  subscriptions = [];

  componentDidMount() {
    const searchQuery = getSearchQueryFromQueryString(this.props.location.search);

    if (searchQuery.length > 3) {
      SearchStoreActions.search(searchQuery);
    }

    this.subscriptions.push(SearchStore.addListener(() => {
      this.setState({ results: SearchStore.getState() });
    }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const searchQuery = getSearchQueryFromQueryString(
        this.props.location.search
      );

      this.setState({ searchQuery });
      SearchStoreActions.search(searchQuery);
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header />

        <PageTitle
          key={
            // we force a component re-render everytime the search query
            // changes, this will trigger a new analytics call and correctly
            // track the search query.
            getSearchQueryFromQueryString(this.props.location.search)
          }
          withTracking
          trackingOptions={{
            search: getSearchQueryFromQueryString(this.props.location.search),
          }}
          title="Search results"
        />

        <PageHeader
          compact
          cover={this.state.collectionCover}
          crumbs={[__('Home'), __('Search results')]}
          preTitle={themeResponsiveProperty(null, __('Your search results for:'))(this.props)}
          title={themeResponsiveProperty(__('Search', `"${getSearchQueryFromQueryString(this.props.location.search)}"`))(this.props)} />

        <RenderOnMobile>
          <MobileSearchContainer onSubmit={event => {
            event.preventDefault();
            this.props.history.push(`/search?q=${this.state.searchQuery}`);
          }}>
            <MobileSearchInput
              ref={element => element !== null && element.focus()}
              autoFocus
              value={this.state.searchQuery}
              required
              minLength={4}
              onChange={event => {
                this.setState({ searchQuery: event.target.value });
              }}
            />

            <button style={{
              ...buttonMutedStyle,
              color: 'rgb(0, 0, 0, .2)',
              padding: '.5rem',
            }}>
              <SearchIcon />
            </button>
          </MobileSearchContainer>
        </RenderOnMobile>

        <div style={{
          maxWidth: '47.5rem',
          margin: themeResponsiveProperty('0 1rem', '2rem auto')(this.props),
          padding: '.0625rem 0',
        }}>
          {this.state.results !== null
            ? this.state.results.length === 0 ? (
              <NoResults
                message={__('No search results for ":query".', { query: getSearchQueryFromQueryString(this.props.location.search) })}
                tip={__('Try to change your search query')}
              />
            ) : (
              <div style={{
                maxWidth: '47.5rem',
                padding: '.0625rem 0',
              }}>
                {this.state.results.map((result, index) => (
                  resultRenderFactory(getSearchQueryFromQueryString(this.props.location.search), result, index)
                ))}
              </div>
            ) : null
          }
        </div>
      </div>
    )
  }
}

export default withRouter(withTheme(Search));

const MobileSearchContainer = styled.form`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-right: 1rem;
  margin-left: 1rem;
  background-color: #f0f0f0;

  > button {
    font-size: 0;
  }

  > button > svg {
    width: 1.125rem;
  }
`;

const MobileSearchInput = styled.input`
  width: 100%;
  padding: .25rem .25rem .25rem .75rem;
  border-width: 0;
  outline: none;
  background-color: transparent;

  &::placeholder {
    color: inherit;
    text-transform: uppercase;
  }
`;
